'use client';

export default function CWSectionHeader({ title }: { title?: string }) {
  return (
    <div className="mx-auto mb-4 flex w-full flex-col items-start px-2 md:mb-4">
      {title && (
        <h2 className="mb-1 text-[22px] font-bold leading-tight text-white md:text-[32px]">
          {title}
        </h2>
      )}
    </div>
  );
}
